import { IonItem, IonLabel, IonIcon, IonButton } from '@ionic/react'
import { checkmarkCircle, ellipseOutline } from 'ionicons/icons'

import { useBoolean } from '../../../hooks/use-boolean'
import SubscriptionEditForm from '../../../components/client/SubscriptionEditForm'
import { InfoCard } from './info-card'

import type { IsoDate } from '../../../types/general'

type Props = {
  clientId: string
  isEditDisabled: boolean
  unsubscribedAt: IsoDate | null
  updateEditStatus: (status: boolean) => void
}

function SubscriptionInfoCard({
  clientId,
  isEditDisabled,
  unsubscribedAt,
  updateEditStatus,
}: Props) {
  const [isEditing, { off: hideEdit, on: showEdit }] = useBoolean()

  return (
    <InfoCard>
      {isEditing ? (
        <SubscriptionEditForm
          clientId={clientId}
          unsubscribedAt={unsubscribedAt}
          onCancel={() => {
            hideEdit()
            updateEditStatus(true)
          }}
          onSave={() => {
            hideEdit()
            updateEditStatus(true)
          }}
        />
      ) : (
        <section>
          <IonItem color="secondary" lines="none">
            <IonLabel color={unsubscribedAt ? 'danger' : 'tertiary'}>
              Do Not Contact
            </IonLabel>
            <IonIcon
              slot="end"
              color={unsubscribedAt ? 'danger' : 'tertiary'}
              icon={unsubscribedAt ? checkmarkCircle : ellipseOutline}
            />
          </IonItem>
          <div className="flex justify-end">
            <IonButton
              size="small"
              fill="outline"
              disabled={isEditDisabled}
              onClick={() => {
                showEdit()
                updateEditStatus(false)
              }}
            >
              Edit
            </IonButton>
          </div>
        </section>
      )}
    </InfoCard>
  )
}

export { SubscriptionInfoCard }
